import React, { useLayoutEffect } from 'react';

import { useTranslation } from 'react-i18next';

import Layout from '../../containers/Layout';
// import InvoicesDueTable from '../../components/Dashboard/InvoicesDueTable';
import UnappliedPaymentsTable from '../../components/Dashboard/UnappliedPaymentsTable';
import UndepositedChecksTable from '../../components/Dashboard/UndepositedChecksTable';
import LoansPendingTable from '../../components/Dashboard/LoansPendingTable';
import InsuranceAlertsTable from '../../components/Dashboard/InsuranceAlertsTable';
import PaymentsDueTable from '../../components/Dashboard/PaymentsDue';
import InvoicesLateTable from '../../components/Dashboard/InvoicesLateTable';
import AddOrEditPageTabs from '../../components/AddOrEditPage/AddOrEditPageTabs';
import TaxAuditTable from '../../components/Dashboard/TaxAuditTable';
import DemandsTable from '../../components/Dashboard/DemandsTable';
import UnmatchedSettlementsTable from '../../components/Dashboard/UnmatchedSettlementsTable';
import UnclearedBillComVendorChecks from '../../components/Dashboard/UnclearedBillComVendorChecks';
import CallsTable from '../../components/Dashboard/CallsTable';
import PayoffsTable from '../../components/Dashboard/PayoffsTable';

import { useServicerStore } from '../../store';
import useAddQueryParam from '../../hooks/useAddQueryParams';

const tabs = [
  {
    label: 'Overview',
  },
  {
    label: 'Accounting',
  },
  {
    label: 'Insurance',
  },
  {
    label: 'Tax',
  },
  {
    label: 'Calls',
  },
  {
    label: 'Payoffs',
  },
];

export default function Dashboard() {
  const { t } = useTranslation();

  const { addQueryParam, currentQueryParam } = useAddQueryParam('tab');

  const userRole = useServicerStore((state) => state.userRole);
  const isSuperAdmin = userRole === 'superAdmin';
  const isBorrower = userRole === 'borrower';
  const isLender = userRole === 'lender';

  const isOverviewTab = currentQueryParam === 'Overview';
  const isAccountingTab = currentQueryParam === 'Accounting';
  const isInsuranceTab = currentQueryParam === 'Insurance';
  const isTaxTab = currentQueryParam === 'Tax';
  const isCallsTab = currentQueryParam === 'Calls';
  const isPayoffsTab = currentQueryParam === 'Payoffs';

  useLayoutEffect(() => {
    if ((isSuperAdmin || isLender) && !currentQueryParam) {
      addQueryParam('tab', 'Overview');
    }
  }, [isSuperAdmin, currentQueryParam, addQueryParam, isLender]);

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    {t('DashboardPage.Dashboard')}
                  </h1>
                </div>
              </div>
              {(isSuperAdmin || isLender) && (
                <div className="mb-4">
                  <AddOrEditPageTabs tabs={isSuperAdmin ? tabs : [tabs[0]]} />
                </div>
              )}

              {/* Table */}
              {isSuperAdmin && (
                <>
                  {isOverviewTab && (
                    <>
                      <div className="mb-10">
                        <InvoicesLateTable />
                      </div>
                      <div className="mt-10">
                        <DemandsTable />
                      </div>
                      <div className="mt-10">
                        <LoansPendingTable />
                      </div>
                    </>
                  )}
                  {isAccountingTab && (
                    <>
                      <div className="mb-10">
                        <UnappliedPaymentsTable />
                      </div>
                      <div className="mb-10">
                        <UndepositedChecksTable />
                      </div>
                      <div className="mb-10">
                        <UnmatchedSettlementsTable />
                      </div>
                      <div>
                        <UnclearedBillComVendorChecks />
                      </div>
                    </>
                  )}
                  {isInsuranceTab && (
                    <div>
                      <InsuranceAlertsTable />
                    </div>
                  )}
                  {isTaxTab && (
                    <div>
                      <TaxAuditTable />
                    </div>
                  )}
                  {isCallsTab && <CallsTable />}
                  {isPayoffsTab && (
                    <div>
                      <PayoffsTable />
                    </div>
                  )}
                </>
              )}
              {isBorrower && <PaymentsDueTable />}
              {isLender && isOverviewTab && (
                <>
                  <div className="mb-10">
                    <InvoicesLateTable />
                  </div>
                  <div className="mt-10">
                    <DemandsTable />
                  </div>
                  <div className="mt-10">
                    <LoansPendingTable />
                  </div>
                </>
              )}
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
